// Get session directly from localStorage to avoid Supabase getSession() blocking
function getSessionFromStorage() {
  try {
    const key = `sb-${process.env.REACT_APP_SUPABASE_URL?.split('//')[1]?.split('.')[0]}-auth-token`;
    const item = localStorage.getItem(key);
    if (!item) return null;

    const data = JSON.parse(item);
    return data;
  } catch (error) {
    console.error('[apiFetch] Error reading session from localStorage:', error);
    return null;
  }
}

import { getViewAs, VIEW_AS_HEADER } from '../utils/viewAs';

// 'Bekijk als': de rechten van een andere gebruiker bootsen we na met een header; de aanvraag om die rechten
// op te halen (…/view-as) gebeurt met de eigen rechten.
function viewAsHeaders(endpoint) {
  const viewAs = endpoint.endsWith('/view-as') || endpoint.startsWith('/users/me') ? null : getViewAs();
  return viewAs ? { [VIEW_AS_HEADER]: viewAs.user_id } : {};
}

// Get API URL from environment variable or default to localhost
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function apiFetch(endpoint, options = {}) {
  console.log(`[apiFetch] Starting request to ${endpoint}`);
  const startTime = Date.now();

  try {
    console.log(`[apiFetch] Getting session from localStorage...`);
    const sessionData = getSessionFromStorage();
    const accessToken = sessionData?.access_token;
    console.log(`[apiFetch] Session obtained in ${Date.now() - startTime}ms, has token:`, !!accessToken);

    const headers = {
      "Content-Type": "application/json",
      ...(accessToken
        ? { Authorization: `Bearer ${accessToken}` }
        : {}),
      ...viewAsHeaders(endpoint),
      ...options.headers,
    };

    console.log(`[apiFetch] Fetching ${API_URL}${endpoint}`);
    const fetchStart = Date.now();
    const res = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers,
    });
    console.log(`[apiFetch] Fetch completed in ${Date.now() - fetchStart}ms, status: ${res.status}`);

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`API-fout ${res.status}: ${text}`);
    }

    const data = await res.json();
    console.log(`[apiFetch] Total request time: ${Date.now() - startTime}ms`);
    return data;
  } catch (error) {
    console.error(`[apiFetch] ERROR after ${Date.now() - startTime}ms at ${endpoint}:`, error);
    throw error;
  }
}

/**
 * Zoals apiFetch, maar voor endpoints die een downloadbaar bestand teruggeven
 * (bv. PDF/XML met Content-Disposition: attachment) in plaats van JSON.
 * Triggert automatisch een browserdownload en geeft de gebruikte bestandsnaam terug.
 */
export async function apiFetchDownload(endpoint, options = {}) {
  const sessionData = getSessionFromStorage();
  const accessToken = sessionData?.access_token;

  const headers = {
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    ...viewAsHeaders(endpoint),
    ...options.headers,
  };

  const res = await fetch(`${API_URL}${endpoint}`, { ...options, headers });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API-fout ${res.status}: ${text}`);
  }

  const blob = await res.blob();
  const disposition = res.headers.get("Content-Disposition") || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : "download";

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);

  return filename;
}
